import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBCollapse,
  MDBIcon,
  MDBTypography
} from 'mdb-react-ui-kit';

import InventoryTab from '../components/InventoryTab';
import ReportTab from '../components/ReportTab';
import HomeTab from '../components/HomeTab';
import StaffManagementTab from '../components/StaffManagementTab.js';
import ProductsTab from '../components/ProductsTab.js';
import OrderTab from '../components/OrderTab.js';

function HomePage() {
  const navigate = useNavigate();

  const [showNav, setShowNav] = useState(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [selectedPage, setSelectedPage] = useState('home'); 

  const location = useLocation();
  const email = location.state?.email;

  useEffect(() => {
    const fetchUser = async () => {
      if (!email) return;
      try {
        const response = await fetch("https://krizkhen-floral-design.onrender.com/api/users/get-user-by-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUser(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchUser();
  }, [email]);

  const navItems = [
    { label: 'Home', key: 'home', roles: ['admin', 'staff'] },
    { label: 'Orders', key: 'orders', roles: ['admin', 'staff'] },
    { label: 'Inventory', key: 'inventory', roles: ['admin', 'staff'] },
    { label: 'Products', key: 'products', roles: ['admin'] },      
    { label: 'Reports', key: 'reports', roles: ['admin'] },        
    { label: 'Staff Management', key: 'staff', roles: ['admin'] }, 
  ];

  const handleTabSelect = (tabKey) => {
    const pageMap = {
      'Orders': 'orders',
      'Inventory': 'inventory',
      'Products': 'products',
      'Reports': 'reports',
      'Staff Management': 'staff'
    };
    setSelectedPage(pageMap[tabKey] || 'home');
  };

  return (
    <>
      {/* NAVBAR */}
      <MDBNavbar expand='lg' style={{ backgroundColor: '#A78D79' }}>
        <MDBContainer fluid className='d-flex justify-content-between align-items-center'>
          {/* Brand */}
          <MDBNavbarBrand
            href='#'
            className='d-flex align-items-center custom-font'
            style={{ color: 'white' }}
            onClick={() => navigate(-1)}
          >
            Krizkhen Floral Design
          </MDBNavbarBrand>

          {/* Nav Links */}
          <div className='d-flex align-items-center'>
            <MDBNavbarToggler
              type='button'
              aria-controls='navbar'
              aria-expanded='false'
              aria-label='Toggle navigation'
              onClick={() => setShowNav(!showNav)}
            >
              <MDBIcon icon='bars' fas style={{ color: 'white' }} />
            </MDBNavbarToggler>

            <MDBCollapse navbar show={showNav}>
              <MDBNavbarNav className='ms-auto d-flex flex-row gap-3 align-items-center'>
                {user &&
                  navItems
                    .filter(item => item.roles.includes(user.role))
                    .map(item => (
                      <MDBNavbarItem key={item.key}>
                        <MDBNavbarLink
                          onClick={() => setSelectedPage(item.key)}
                          style={{
                            color: 'white',
                            textDecoration:
                              selectedPage === item.key ? 'underline' : 'none',
                            textUnderlineOffset: '6px',
                            cursor: 'pointer'
                          }}
                        >
                          {item.label}
                        </MDBNavbarLink>
                      </MDBNavbarItem>
                    ))}
              </MDBNavbarNav>
            </MDBCollapse>
          </div>
        </MDBContainer>
      </MDBNavbar>

      {/* MAIN CONTENT */}
      <MDBContainer fluid className="mt-4">
        {error ? (
          <MDBTypography tag='p' className='text-danger'>
            Error: {error}
          </MDBTypography>
        ) : !user ? (
          <MDBTypography tag='p' className='lead text-muted'>
            Loading user...
          </MDBTypography>
        ) : (
          <>
            {/* Home Page */}
            {selectedPage === 'home' && <HomeTab user={user} onTabSelect={handleTabSelect} />}

            {/* Orders Page */}
            {selectedPage === 'orders' && <OrderTab user={user} />}

            {/* Inventory Page */}
            {selectedPage === 'inventory' && <InventoryTab user={user}/>}

            {/* Products Page (Admin only) */}
            {selectedPage === 'products' && <ProductsTab />}

            {/* Reports Page (Admin only) */}
            {selectedPage === 'reports' && user.role === 'admin' && <ReportTab/>}

            {/* Staff Management Page (Admin only) */}
            {selectedPage === 'staff' && <StaffManagementTab />}
          </>
        )}
      </MDBContainer>
    </>
  );
}

export default HomePage;
